import { Component, inject, input, computed } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ICadastreLandRegistrationReportUrls } from "@models/public-info-urls";
import { CapitalizePipe } from "ev-core";
import { EvRangebarModule } from "ev-rangebar";
import { ConstraintRegisteredType, IAggregatedSpecialConstraintData } from "src/models/units/special-constraints.model";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";

@Component({
    selector: "special-constraints",
    templateUrl: "./specialconstraints.component.html",
    styleUrls: ["./specialconstraints.component.scss"],
    imports: [EvRangebarModule, CapitalizePipe],
})
export class SpecialConstraintsComponent {
    readonly data = input<IAggregatedSpecialConstraintData[]>(undefined);
    readonly registeredType = input<ConstraintRegisteredType>(ConstraintRegisteredType.Unknown);
    readonly hideLandRegUrl = input<boolean>(undefined);
    readonly reportUrls = input<ICadastreLandRegistrationReportUrls>(undefined);

    authorizationService = inject(EvAuthorizationService);

    judicialTypes = ConstraintRegisteredType;
    canSeeLink = toSignal(this.authorizationService.hasPermission(EVServiceType.EvWeb_LandRegistryPrintout));

    protected url = computed(() => {
        if (this.hideLandRegUrl() === true) {
            return null;
        }
        return this.reportUrls()?.landRegistrationReportUrl;
    });
}
